import {
  ApiBlobGetRequest,
  ApiDeleteRequest,
  ApiGetRequest,
  ApiPostRequest,
  ApiPutRequest,
  //   ApiPostRequest,
  //   ApiDeleteRequest,
  //   ApiPutRequest,
} from '../../../api';
// import { _ } from 'vue-underscore';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Kas Masuk',
    title_form: 'Form Kas Masuk',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Kas Masuk',
        href: '/adm/fin/kas-bank/kas-masuk',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_kas_masuk',
    sortDesc: true,
    fields: [
      {
        key: 'code_kas',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'tgl_bayar',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'from_data',
        label: 'Disetor Oleh',
        sortable: true,
      },
      {
        key: 'memo',
        label: 'Keterangan',
        sortable: true,
      },
      {
        key: 'total_kas',
        label: 'Total',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    form: {
      date_journal: '',
      notes: '',
      id_principle: '',
      principle_name: '',
      acc_cash: '',
      acc_cash_code: '',
      acc_cash_name: '',
      items: [
        {
          id_account: '',
          id_department: '',
          description: '',
          debet: '',
          kredit: '',
        },
      ],
    },
    journal: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  journal(state) {
    return state.data.journal;
  },
};

export const mutations = {
  changeKasMasuk(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getJournalKasMasuk({ commit }, paylad = null) {
    commit('changeKasMasuk', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/kas-masuk/${paylad.id}/journal`);
    commit('changeKasMasuk', {
      loading: false,
      journal: result.error ? [] : result.data.object,
    });

    return !result.error ? true : false;
  },

  async getKasMasuk({ commit, state }, payload = {}) {
    commit('changeKasMasuk', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...payload,
      start_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`fin/kas-masuk`, params);
      commit('changeKasMasuk', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_kas_masuk.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest('fin/kas-masuk', params);
      commit('changeKasMasuk', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getDetailKasMasuk({ commit, state }, payload = null) {
    commit('changeKasMasuk', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/kas-masuk/${payload.id}`);
    commit('changeKasMasuk', {
      loading: false,
    });

    if (!result.error) {
      commit('changeKasMasuk', {
        form: {
          ...data.form,
          ...result.data.object,
          tgl_bayar: result.data.object.tgl_bayar
            ? moment(result.data.object.tgl_bayar).format('DD/MM/YYYY')
            : '',
        },
      });

      return true;
    }

    return false;
  },

  async getLastId({ commit, state }) {
    commit('changeKasMasuk', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/kas-masuk/get_last_id`);
    commit('changeKasMasuk', {
      loading: false,
    });

    if (!result.error) {
      commit('changeKasMasuk', {
        form: {
          ...data.form,
          code_journal: result.data.object,
        },
      });

      return true;
    }

    return false;
  },

  async createKasMasuk({ commit, state, dispatch }) {
    commit('changeKasMasuk', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest('fin/kas-masuk', data.form);
    commit('changeKasMasuk', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async updateKasMasuk({ commit, state, dispatch }, payload = null) {
    commit('changeKasMasuk', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(`fin/kas-masuk/${payload.id}`, data.form);

    commit('changeKasMasuk', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async deleteKasMasuk({ commit, dispatch }, payload = null) {
    commit('changeKasMasuk', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`fin/kas-masuk/${payload.id}`);
    commit('changeKasMasuk', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async getDetailSetupAccount({ commit }, payload = null) {
    commit('changeKasMasuk', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/kas-masuk/${payload.id}`);
    commit('changeKasMasuk', {
      loading: false,
    });

    if (!result.error) {
      commit('changeKasMasuk', {
        detail: result.data.object,
      });
    }

    return !result.error ? true : false;
  },
};
